// NEW BLOCK OF COLORS
export const TITLE_MODAL_BKG_COLOR = '#3f883a42'
export const ACTION_MODAL_TEXT_BUTTON_COLOR = "#325602"


//OLD BLOCK OF COLORS

export const PADDING_BASE = '1rem'
export const PADDING_BLOCK_FORM = '1rem'
export const MARGIN_PAPER_FORM = '1rem'

export const GREEN_BASE = "#37c33c"
export const GREEN_DARK = "#028306"
export const GREEN_VERY_DARK = "#325602"
export const GREEN_LIGHT = "#2ae131"

// Green background
export const GREEN_BKG_DARK = "#c6c9c4"
export const GREEN_BKG_TITLE_BAR = "#cbe0ca63"
export const GREEN_BKG_FORM = "#7aaf7c54"
export const GREEN_BKG_MODAL_TITLE = "#b5c3b8"

//

// Combos
export const GREEN_TEXT_OPT_SELECTED = "#7aaf7c54"
export const GREEN_BKG_OPT_SELECTED = "#7aaf7c54"
export const DISABLED_BKG = "#eeeeee"
export const DISABLED_TEXT = "#6066a1"

// Grays
export const GRAY = "#bcbcbc"
export const GRAY_TEXT = "#00000061"
export const GRAY_DARK = "#302f2f"
export const GRAY_LIGHT = "#dae2ed"
export const GRAY_VERY_LIGHT = "#eeeeee"

// Highlight
export const RED_LIGHT = "#e5bfbf"
export const RED = "#e95353"
export const RED_DARK = "#b50303"

//PRIORITIES
export const RED_PR_1 = "#f10a0ab0"
export const ORANGE_PR_2 = "#ff7600bf"
export const YELLOW_PR3 = "#d9d523"
export const BLUE_PR4 = "#3791DF"
export const GREEN_PR5 = '#23a73b'
export const DEFAULT_COLOR_PR = '#b6b7b6'

//BOX INDICATORS
export const BOX_LEGEND_BKG = "#243d1cfa"
export const BOX_LEGEND_TEXT = "#fff"
export const BOX_CONTENT_BKG = "#f0ffff"

//CHIP INDICATORS
export const CHIP_CONTENT_BKG = "#55b56682"
export const CHIP_CONTENT_TEXT = "#0c0000"

//INFO CONTAINER
export const INFO_CONTAINER_TEXT = '#a51a94'



